import { Text } from '@dixa/lib-shared-habla';
import type { SearchConversationEnriched } from 'lib-search-types';

import { useConversationRow } from '../../../utils/useConversationRow';

type ConversationsTableMessageCountProps = {
  countKey: keyof Pick<
    SearchConversationEnriched,
    'inbound_message_count' | 'non_automated_outbound_message_count'
  >;
};

/** Represents the content of a message count cell in the conversations table. */
export const ConversationsTableMessageCount = ({
  countKey,
}: ConversationsTableMessageCountProps): JSX.Element => {
  const { conversation } = useConversationRow();
  const count = conversation[countKey];

  if (count === undefined || count === null) {
    return (
      <Text.Paragraph variant="2" color="tertiary">
        n.a.
      </Text.Paragraph>
    );
  }

  return (
    <Text.Paragraph>{count.toLocaleString(navigator.language)}</Text.Paragraph>
  );
};
